import { get } from 'svelte/store';
import { home_data } from 'src/stores/account/user';
import { app, android_version, ios_version, os } from 'src/stores/session/native-bridge';
import { app_icon } from 'src/stores/session/preferences';
import { compare } from 'compare-versions';
import AppIconModal from 'src/components/AppIconModal.svelte';
import type { ModalConfig } from 'src/types/Modals';
import { CHANGE_DATE } from 'src/constants';
import { change_app_icon_android } from 'src/services/native_container_requests_android';
import { change_app_icon_ios } from 'src/services/native_container_requests_ios';

export const isDecember = (): boolean => new Date().getMonth() === 11;

export const validateNativeVersionAppIcon = (): boolean => {
	const currentOs = get(os);

	const androidVersion = get(android_version);
	const iosVersion = get(ios_version);

	const minAndroidVersion = '1.35.5';
	const minIosVersion = '1.7.8';

	if (currentOs === 'IOS') {
		return compare(iosVersion, minIosVersion, '>=');
	} else if (currentOs !== '') {
		return compare(androidVersion, minAndroidVersion, '>=');
	}
	return false;
};

const isItTimeForAppIconModal = (): boolean => {
	const homeData = get(home_data);

	if (!homeData?.appIconModal) {
		return true;
	}

	return CHANGE_DATE.APP_ICON_MODAL > homeData?.appIconModal;
};

const shouldShowAppIconModal = (): boolean => {
	const isApp = get(app);
	if (!isApp) return false;

	if (!isDecember()) return false;

	if (!isItTimeForAppIconModal()) return false;

	if (!validateNativeVersionAppIcon()) return false;

	return true;
};

export const resetChristmasIconIfNeeded = (): void => {
	const currentIcon = get(app_icon);
	if (currentIcon !== 'Icon-Christmas2025' || isDecember()) return;

	const currentOs = get(os);

	if (currentOs === 'IOS') {
		change_app_icon_ios('default');
	} else if (currentOs !== '') {
		change_app_icon_android('default');
	}

	app_icon.set('default');
};

export const AppIconModalConfig: ModalConfig = {
	id: 'appIconState',
	component: AppIconModal,
	props: {
		priority: 40, // Low priority
		showModal: true,
	},
	rules: [
		{
			check: () => {
				return shouldShowAppIconModal();
			},
			expected: true,
		},
	],
};
